const FLAG = 'pds.fake';

// Données fictives : démonstration et maquette, jamais dans une version de production.
// `?fake=1` les active pour la session, `?fake=0` les retire.
export const usesFakeData = () => {
  if (!import.meta.env.DEV) return false;
  try {
    const asked = new URLSearchParams(window.location.search).get('fake');
    if (asked === '1') sessionStorage.setItem(FLAG, '1');
    if (asked === '0') sessionStorage.removeItem(FLAG);
    return sessionStorage.getItem(FLAG) === '1';
  } catch {
    return false;
  }
};
